module.exports = __webpack_public_path__ + "r-v3/img/mic_off_white.a619251d.svg";